import valwinHorizontal from '~shared/assets/images/valwin-horizontal.svg';
import valwinLogoLarge from '~shared/assets/images/valwin-large.png';
import valwinLogoSquare from '~shared/assets/images/valwin-square.png';

export function LogoSmall() {
  return <img width="30" src={valwinLogoSquare} alt="logo" />;
}

export function LogoHorizontal() {
  return (
    <img
      src={valwinHorizontal}
      alt="Valwin"
      style={{ height: '30px', width: 'auto' }}
    />
  );
}

export function LogoLarge() {
  return <img src={valwinLogoLarge} width="120" alt="logo" />;
}
